import { Program } from '@/types/programs';

export const issueBasedPrograms: Program[] = [
  {
    id: 1,
    title: "Anxiety Management",
    description: "Learn effective techniques to manage anxiety and reduce stress in your daily life.",
    duration: "4 weeks",
    image: "/lovable-uploads/1b420877-7be1-4010-b806-5850cb719642.png",
    category: "mental_health",
    sessions: 8,
    price: 299,
    created_at: "2024-01-01",
    enrollments: 150,
    programType: "wellness",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 2,
    title: "Depression Support",
    description: "Comprehensive support program for those dealing with depression.",
    duration: "6 weeks",
    image: "/lovable-uploads/1debddfd-ebd1-41dd-98cb-90a9c97f0b3a.png",
    category: "mental_health",
    sessions: 12,
    price: 399,
    created_at: "2024-01-02",
    enrollments: 89,
    programType: "wellness",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 3,
    title: "Stress Reduction",
    description: "Simple and effective techniques to reduce stress and improve your overall wellbeing.",
    duration: "3 weeks",
    image: "/lovable-uploads/4298499f-7571-412b-9966-9838009c9809.png",
    category: "mental_health",
    sessions: 6,
    price: 199,
    created_at: "2024-01-03",
    enrollments: 212,
    programType: "wellness",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 4,
    title: "Mindfulness Practices",
    description: "Learn mindfulness practices to improve focus and reduce stress.",
    duration: "4 weeks",
    image: "/lovable-uploads/51999999-5199-4959-9959-599999999959.png",
    category: "mental_health",
    sessions: 8,
    price: 249,
    created_at: "2024-01-04",
    enrollments: 188,
    programType: "wellness",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 5,
    title: "Relationship Building",
    description: "Improve your relationships with effective communication and empathy.",
    duration: "5 weeks",
    image: "/lovable-uploads/60666666-6066-4606-8606-666666666606.png",
    category: "relationships",
    sessions: 10,
    price: 349,
    created_at: "2024-01-05",
    enrollments: 115,
    programType: "wellness",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 6,
    title: "Effective Communication",
    description: "Master the art of effective communication in your personal and professional life.",
    duration: "4 weeks",
    image: "/lovable-uploads/77777777-7777-4777-b777-777777777777.png",
    category: "relationships",
    sessions: 8,
    price: 299,
    created_at: "2024-01-06",
    enrollments: 95,
    programType: "wellness",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 7,
    title: "Conflict Resolution",
    description: "Learn how to resolve conflicts peacefully and constructively.",
    duration: "3 weeks",
    image: "/lovable-uploads/88888888-8888-4888-a888-888888888888.png",
    category: "relationships",
    sessions: 6,
    price: 199,
    created_at: "2024-01-07",
    enrollments: 167,
    programType: "wellness",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 8,
    title: "Career Advancement",
    description: "Strategies and techniques to advance your career and achieve your professional goals.",
    duration: "6 weeks",
    image: "/lovable-uploads/99999999-9999-4999-b999-999999999999.png",
    category: "career",
    sessions: 12,
    price: 399,
    created_at: "2024-01-08",
    enrollments: 78,
    programType: "business",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 9,
    title: "Leadership Skills",
    description: "Develop essential leadership skills to inspire and motivate your team.",
    duration: "5 weeks",
    image: "/lovable-uploads/aaaaaaa-aaaa-4aaa-aaaa-aaaaaaaaaaaa.png",
    category: "career",
    sessions: 10,
    price: 349,
    created_at: "2024-01-09",
    enrollments: 132,
    programType: "leadership",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 10,
    title: "Time Management",
    description: "Learn how to manage your time effectively and increase your productivity.",
    duration: "4 weeks",
    image: "/lovable-uploads/bbbbbbbb-bbbb-4bbb-bbbb-bbbbbbbbbbbb.png",
    category: "productivity",
    sessions: 8,
    price: 299,
    created_at: "2024-01-10",
    enrollments: 101,
    programType: "productivity",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 11,
    title: "Goal Setting",
    description: "Set achievable goals and create a plan to reach them.",
    duration: "3 weeks",
    image: "/lovable-uploads/cccccccc-cccc-4ccc-accc-cccccccccccc.png",
    category: "productivity",
    sessions: 6,
    price: 199,
    created_at: "2024-01-11",
    enrollments: 175,
    programType: "productivity",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 12,
    title: "Personal Finance",
    description: "Learn how to manage your personal finances and achieve financial stability.",
    duration: "6 weeks",
    image: "/lovable-uploads/dddddddd-dddd-4ddd-bddd-dddddddddddd.png",
    category: "business",
    sessions: 12,
    price: 399,
    created_at: "2024-01-12",
    enrollments: 65,
    programType: "business",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 13,
    title: "Entrepreneurship",
    description: "Start your own business with our comprehensive entrepreneurship program.",
    duration: "8 weeks",
    image: "/lovable-uploads/eeeeeeee-eeee-4eee-beee-eeeeeeeeeeee.png",
    category: "business",
    sessions: 16,
    price: 499,
    created_at: "2024-01-13",
    enrollments: 42,
    programType: "business",
    is_featured: true,
    is_favorite: false
  },
  {
    id: 14,
    title: "Academic Success",
    description: "Strategies and techniques to achieve academic success.",
    duration: "5 weeks",
    image: "/lovable-uploads/ffffffff-ffff-4fff-afff-ffffffffffff.png",
    category: "academic",
    sessions: 10,
    price: 349,
    created_at: "2024-01-14",
    enrollments: 148,
    programType: "academic",
    is_featured: false,
    is_favorite: false
  },
  {
    id: 15,
    title: "Study Skills",
    description: "Improve your study skills and achieve better grades.",
    duration: "4 weeks",
    image: "/lovable-uploads/10101010-1010-4010-b010-101010101010.png",
    category: "academic",
    sessions: 8,
    price: 299,
    created_at: "2024-01-15",
    enrollments: 122,
    programType: "academic",
    is_featured: true,
    is_favorite: false
  }
];
